"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.corners = exports.wall = exports.vec3 = exports.box = exports.segment = exports.point = void 0;
const point = (x, y) => ({ kind: "point", at: { x, y } });
exports.point = point;
const segment = (x0, y0, x1, y1) => ({
    kind: "segment",
    from: { x: x0, y: y0 },
    to: { x: x1, y: y1 },
});
exports.segment = segment;
/** An axis-aligned rectangle, corners in the protocol's order. */
const box = (x0, x1, y0, y1) => ({
    kind: "polygon",
    points: [
        { x: x0, y: y0 },
        { x: x1, y: y0 },
        { x: x1, y: y1 },
        { x: x0, y: y1 },
    ],
});
exports.box = box;
const vec3 = (x, y, z) => ({ x, y, z });
exports.vec3 = vec3;
/**
 * A wall from `from` to `to`, `height` tall, stopping balls from its left.
 * Walls around a court run counterclockwise seen from above, so their left
 * is always the court.
 */
const wall = (id, from, to, height, response) => ({
    id,
    kind: "wall",
    from,
    to,
    bottom: 0,
    top: height,
    faces: "left",
    response,
});
exports.wall = wall;
/** The four corners of an axis-aligned rectangle centered on the origin. */
const corners = (halfWidth, halfLength) => ({
    nearLeft: { x: -halfWidth, y: -halfLength },
    nearRight: { x: halfWidth, y: -halfLength },
    farRight: { x: halfWidth, y: halfLength },
    farLeft: { x: -halfWidth, y: halfLength },
});
exports.corners = corners;
